import React, { useState, useEffect } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import House from "../../Assets/images/rentrental.png";
import Wallet from "../../Assets/images/w.png";
import Card from "../../Assets/images/c1.png";
import Master from "../../Assets/images/master.png";
import getServices from "../../Services/get-service";
import Constant from "../../Constant";
import Summary from "./Summary";
import EnterPin from "./EnterPin";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 430,
  heigt: "80%",
  bgcolor: "white",
  boxShadow: 24,
  borderRadius: "16px",
  p: 4,
  maxWidth: "95%",
  outline: "none",
  maxHeight: "90vh",
  overflowY: "auto",
};

function PaymentMethod({ open, handleClose, data, handleCloseSidebar, isRenewal }) {
  const [value, setValue] = useState("wallet");
  const [walletBalance, setWalletBalance] = useState();
  const [openSummary, setOpenSummary] = useState(false);
  const [openPin, setOpenPin] = useState(false);

  useEffect(() => {
    if (open) {
      getServices.getWalletBalance().then(
        (response) => {
          if (response.data.statusCode === 200) {
            const walletData = response.data.data[0];
            setWalletBalance(walletData.availableBalance);
          }
        },
        (error) => {
          // console.error(error)
        },
      );
    }
  }, [open]);

  const handleContinueLocal = () => {
    setOpenSummary(true);
  };

  const handleCloseSummary = () => {
    setOpenSummary(false);
  };

  const handleBackFromSummary = () => {
    setOpenSummary(false);
  };

  const handleSummaryContinue = () => {
    setOpenSummary(false);
    setOpenPin(true);
  };

  const handleClosePin = () => {
    setOpenPin(false);
  };

  const handlePinConfirm = () => {
    setOpenPin(false);
    handleClose();
  };

  return (
    <>
      <Summary
        open={openSummary}
        handleClose={handleCloseSummary}
        handleBack={handleBackFromSummary}
        handleContinue={handleSummaryContinue}
        data={data}
        isRenewal={isRenewal}
      />
      <EnterPin
        open={openPin}
        handleClose={handleClosePin}
        handleConfirm={handlePinConfirm}
        handleCloseSidebar={handleCloseSidebar}
        data={data}
        isRenewal={isRenewal}
      />
      <Modal
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            {/* Header */}
            <div className="flex justify-between items-center mb-6">
              <div
                className="flex items-center gap-3 cursor-pointer"
                onClick={handleClose}
              >
                <ArrowBackIcon className="text-back-color2" />
                <p className="font-[700] text-[16px] text-back-color2">Back</p>
              </div>
              <IconButton
                onClick={handleClose}
                sx={{
                  bgcolor: "#1F2937",
                  color: "white",
                  "&:hover": { bgcolor: "#374151" },
                  width: 36,
                  height: 36,
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </div>

            {/* Apartment Details Card */}
            <div className="border border-gray-100 rounded-2xl p-3 flex gap-4 items-center mb-6 shadow-sm">
              <img
                src={
                  data?.apartmentClassImagesDTOS?.[0]?.imageUrl || House
                }
                alt="apartment"
                className="w-20 h-20 rounded-xl object-cover"
              />
              <div>
                <p className="text-[15px] font-[700] text-back-color2 mb-1">
                  {data?.apartmentTitle || ""}
                  {data?.bedRooms ? ` (Room ${data.bedRooms})` : ""}
                </p>
                <p className="text-[12px] text-gray-500 mb-2 flex items-center gap-1">
                  <FmdGoodOutlinedIcon sx={{ fontSize: 14 }} />
                  {data?.locality || ""}
                </p>
                <p className="text-[14px] font-[700] text-[#00BC67]">
                  NGN {data?.price?.toLocaleString() || ""}
                  <span className="text-gray-400 font-[400] text-[12px]">
                    /year
                  </span>
                </p>
              </div>
            </div>

            <p className="font-[700] text-[16px] text-back-color2 mb-4">
              Payment method
            </p>

            <RadioGroup
              value={value}
              className="w-full mb-6"
              onChange={(e) => setValue(e.target.value)}
            >
              {/* Wallet Option */}
              <div
                className={`w-full rounded-xl border p-3 mb-3 flex items-center justify-between transition-colors ${value === "wallet" ? "border-[#00BC67] bg-[#F5FCF8]" : "border-[#E6E6E7] bg-white"}`}
              >
                <div className="flex items-center gap-3">
                  <div className="bg-[#E6F8F0] p-2 rounded-full">
                    <img
                      src={Wallet}
                      alt="Wallet"
                      className="w-5 h-5 object-contain"
                    />
                  </div>
                  <p className="text-[#1E222B] text-[15px] font-[600]">
                    Wallet
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  <p className="text-[#1E222B] font-[700] text-[14px]">
                    NGN{" "}
                    {Constant.FormatNumber(walletBalance)}
                  </p>
                  <FormControlLabel
                    value="wallet"
                    control={
                      <Radio
                        sx={{
                          color: "#C4C4C4",
                          "&.Mui-checked": { color: "#00BC67" },
                        }}
                      />
                    }
                    label=""
                    className="m-0"
                  />
                </div>
              </div>

              {/* Card Option */}
              {/* <div className={`w-full rounded-xl border p-3 mb-3 flex items-center justify-between transition-colors ${value === 'card' ? 'border-[#00BC67] bg-[#F5FCF8]' : 'border-[#E6E6E7] bg-white'}`}>
                <div className='flex items-center gap-3'>
                  <div className='bg-[#E6F8F0] p-2 rounded-full'>
                    <img src={Card} alt='Card' className='w-5 h-5 object-contain' />
                  </div>
                  <p className='text-[#1E222B] text-[15px] font-[600]'>Card</p>
                </div>
                <div className='flex items-center gap-2'>
                  <p className='text-[#1E222B] font-[700] text-[14px] flex items-center gap-2'>
                    **** 2898 <img src={Master} alt='Mastercard' className='w-6 h-auto object-contain' />
                  </p>
                  <FormControlLabel
                    value="card"
                    control={<Radio sx={{ color: '#C4C4C4', '&.Mui-checked': { color: '#00BC67' } }} />}
                    label="" className="m-0"
                  />
                </div>
              </div> */}

              {/* Paystack Option */}
              {/* <div className={`w-full rounded-xl border p-3 flex items-center justify-between transition-colors ${value === 'paystack' ? 'border-[#00BC67] bg-[#F5FCF8]' : 'border-[#E6E6E7] bg-white'}`}>
                <div className='flex items-center gap-3'>
                  <div className='bg-[#E6F8F0] p-2 rounded-full'>
                    <img src={Card} alt='Paystack' className='w-5 h-5 object-contain' />
                  </div>
                  <p className='text-[#1E222B] text-[15px] font-[600]'>Online payment (Paystack)</p>
                </div>
                <div className='flex items-center'>
                  <FormControlLabel
                    value="paystack"
                    control={<Radio sx={{ color: '#C4C4C4', '&.Mui-checked': { color: '#00BC67' } }} />}
                    label="" className="m-0"
                  />
                </div>
              </div> */}
            </RadioGroup>

            {/* <div className='flex gap-4 mb-6'>
              <button className='flex-1 bg-[#1F2937] text-white font-[600] py-3 rounded-xl text-[14px]'>
                Choose other card
              </button>
              <button className='flex-1 bg-[#F9FAFB] text-[#00BC67] font-[600] py-3 rounded-xl text-[14px] flex items-center justify-center gap-1 border border-gray-100'>
                New card <span>+</span>
              </button>
            </div> */}

            <div className="bg-[#F5FBF8] rounded-xl p-3 flex gap-3 items-start mb-6">
              <InfoOutlinedIcon
                sx={{ color: "#00BC67", fontSize: 20, mt: 0.5 }}
              />
              <p className="text-[12px] text-[#00BC67] leading-relaxed font-[400]">
                Your payment is secured with bank-grade encryption, you will be
                redirected to our secure payment gateway to complete the
                transaction
              </p>
            </div>

            <button
              onClick={handleContinueLocal}
              className="w-full bg-[#00BC67] text-white font-[700] py-4 rounded-xl transition-colors text-[18px]"
            >
              Continue
            </button>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}

export default PaymentMethod;
